<template>
  <div>
    <mu-paper class="insetGraph">
      <mu-row class="headingRow">
        <mu-col class="deviceHeading" width="100" tablet="100" desktop="75">
          <mu-row v-if="service != 'LCP'">
            <mu-col width="15" tablet="15" desktop="15" v-if="service != 'LCP'">
              <mu-icon-button icon="chevron_left" @click.native="subtractDay"></mu-icon-button>
            </mu-col>
            <mu-col width="70" tablet="70" desktop="70">
              <span class="mediumTitle" v-text="humanizeDate"></span>
            </mu-col>
            <mu-col width="15" tablet="15" desktop="15">
              <mu-icon-button icon="chevron_right" @click.native="addDay" :disabled="isToday"></mu-icon-button>
            </mu-col>
          </mu-row>
        </mu-col>
        <mu-col width="100" tablet="100" desktop="25">
          <service-tracking-types type="sleep"/>
        </mu-col>
      </mu-row>


      <sleep-wearable-line-graph v-if="service === 'LCP'"></sleep-wearable-line-graph>

      <fitbit-sleep-graph
        v-if="!isLoading && service === 'FITBIT'"
        :fitbitData="fitbitData"
      ></fitbit-sleep-graph>

      <striiv-sleep-graph
        v-if="!isLoading && service === 'STRIIV'"
        :striivData="striivData"
      />

      <mu-card style="min-height: 430px" class="card-spacing" v-if="isLoading && service != 'LCP'" align="center">
        <mu-card-text>
          {{$t('message.loadingText')}}
          <mu-circular-progress></mu-circular-progress>
        </mu-card-text>
      </mu-card>
    </mu-paper>

    <mu-row gutter v-if="$store.state.user.scope" class="content">
      <mu-col desktop="30" tablet="50" style="padding-top: 24px;">

        <mu-card class="card-spacing" v-if="isLoading && service != 'LCP'" align="center">
          <mu-card-text>
            <mu-circular-progress></mu-circular-progress>
          </mu-card-text>
        </mu-card>

        <striiv-sleep-stages
          class="card-spacing"
          v-if="!isLoading && service === 'STRIIV'"
          :striivData="striivData"
          :date="humanizeDate"
        ></striiv-sleep-stages>

        <fitbit-sleep-stages
          class="card-spacing"
          v-if="!isLoading && service === 'FITBIT'"
          :fitbitData="fitbitData"
          :date="humanizeDate"
        ></fitbit-sleep-stages>


        <sleep-input class="card-spacing"></sleep-input>

        <sleep-visualisation v-if="$store.state.cards.sleep.wearable"></sleep-visualisation>

        <tracking-exporter
          type="sleep"
        ></tracking-exporter>

        <tracking-notifier
          :userId="$store.state.user.scope.user_id"
        ></tracking-notifier>
      </mu-col>
      <mu-col desktop="70" tablet="50">
        <mu-card
          style="margin-top: 24px;"
          id="blood-glucose-data"
          class="tracking-data"
        >


          <mu-tabs v-model="mode">
            <mu-tab value="DEVICE" @click.native="mode = 'DEVICE'">{{$t('message.labelFromDevice').charAt(0).toUpperCase() + $t('message.labelFromDevice').substr(1)}}</mu-tab>
            <mu-tab value="SELF_REPORTED" @click.native="mode = 'SELF_REPORTED'">{{$t('message.labelManualEntry')}}</mu-tab>
          </mu-tabs>

          <mu-timeline>
            <mu-content-block v-if="data.data.length === 0 && !isReadingsLoading"
                              style="text-align: center;padding-bottom: 24px;">
              <!--
                        <h3>{{$t('message.activityStepsEmptyTitle')}}</h3>
                        <p>{{$t('message.activityStepsEmptySubTitle')}}</p>
                        <mu-raised-button @click.native="getStartedIntegrations"
                                          :label="$t('message.activityStepsEmptyButton')"></mu-raised-button>
                                          -->

              <h3>You don't have any sleep data yet</h3>
              <p>To get started connect your favorite health app below</p>
              <mu-raised-button @click.native="getStartedIntegrations"
                                label="Add a sleep integration"></mu-raised-button>
            </mu-content-block>

            <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
              <div v-for="titleItem, titleIndex in group" :key="'title-index-' + titleIndex" v-if="titleIndex === 0"
                   class="timelineSpacing">
                <div class="bold timelineTitle groupedDate"
                     v-text="groupedDateFormat(titleItem.date_created)">
                </div>
              </div>
              <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index"
                   v-bind:class="{notEditMode: !item.isEditMode}">
                <mu-timeline-item
                  :iconColor="btnColor"
                  iconLine="8"
                  iconType="solid"
                >
                  <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}">
                    <mu-row>
                      <mu-col>
                        <div class="trackingDate" v-if="!item.isEditMode"
                             v-text="groupedItemDate(item.date_created)"></div>
                        <div>{{$t('message.labelEfficiency')}}: {{item.efficiency}}%</div>
                        <div>{{$t('message.labelTimeInBed')}}: {{getTime(item.timeInBed)}}</div>
                        <div>{{$t('message.labelTimeAwake')}}: {{getTime(item.minutesAwake)}}</div>
                      </mu-col>
                      <mu-col>
                        <div v-if="!item.isEditMode" class="reading">
                          {{getTime(item.minutesAsleep)}}
                        </div>
                      </mu-col>
                    </mu-row>
                  </div>
                </mu-timeline-item>
              </div>
            </div>
          </mu-timeline>
          <mu-card-text align=" center" v-if="isReadingsLoading">
            <mu-circular-progress color="#0179d5"></mu-circular-progress>
            <div v-text="$t('message.loadingText')"></div>
          </mu-card-text>
          <div v-if="!isReadingsLoading" ref="detector"></div>
        </mu-card>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>
  import config from '../../config'
  import EventBus from '../../helpers/EventBus'

  import SleepGraph from "../../components/Tracking/Graphs/Sleep/LineGraph";
  import TrackingDetailMixin from '../../mixins/TrackingDetailMixin'

  import SleepApi from '../../api/Tracking/Sleep'
  import IntegrationApi from '../../api/Integrations'

  import SleepInput from "../../components/Tracking/Input/Sleep/Sleep";

  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue";
  import TrackingExporter from "../../components/Tracking/Exporter/Exporter.vue";

  import FitbitSleepGraph from "../../components/Tracking/Graphs/Sleep/FitbitSteppedChart";
  import FitbitSleepStages from "../../components/Tracking/Graphs/Sleep/FitbitSleepStages.vue";

  import StriivSleepGraph from "../../components/Tracking/Graphs/Sleep/StriivSleepGraph";
  import StriivSleepStages from "../../components/Tracking/Graphs/Sleep/StriivSleepStages";
  import ServiceTrackingTypes from "../../components/Tracking/ServiceTrackingTypes/ServiceTrackingTypes";
  import SleepWearableLineGraph from "../../components/Tracking/Graphs/SleepWearable/LineGraph";
  import SleepVisualisation from "../../components/Tracking/Visualizations/Sleep/SleepVisualisation";

  export default {
    mixins: [TrackingDetailMixin],
    components: {
      SleepVisualisation,
      SleepWearableLineGraph,
      ServiceTrackingTypes,
      StriivSleepGraph,
      StriivSleepStages,
      FitbitSleepGraph,
      FitbitSleepStages,
      TrackingExporter,
      TrackingNotifier,
      SleepInput,
      SleepGraph
    },
    watch: {
      "date": function () {
        let self = this;

        if (self.locksDate === false) {
          self.isLoading = true;
          if (self.service === 'FITBIT') {
            self.loadFitbitData();
          }
          if (self.service === 'STRIIV') {
            self.loadStriivData();
          }
        }
      },
      "mode": function () {
        if(this.mode === 'SELF_REPORTED') {
          this.$router.push({
            path: '/tracking/sleep/'
          })
        }
      },
      "service": function () {
        let self = this;
        self.isLoading = true;
        if (self.service === 'FITBIT') {
          self.loadFitbitSleepLog();
        }
        if (self.service === 'STRIIV') {
          self.loadStriivData();
        }
      }
    },
    data() {
      return {
        service: 'LCP',
        mode: 'DEVICE',
        striivData: {},
        fitbitIndex: 0,
        fitbitData: {},
        fitbitSleepLog: [],
        isLoading: false,
        date: moment(),
        btnColor: '#183A43',
        selectedTab: 'sleepDiary',
        showDeviceTab: false,
        pageReady: false,
        locksDate: true,
      }
    },
    methods: {
      getStartedIntegrations() {
        let self = this;
        self.$router.push({
          name: 'SettingsIntegrations'
        })
      },
      getTime(minutes) {
        moment.relativeTimeThreshold('m', 60);
        moment.relativeTimeThreshold('s', 60);
        let start = moment();
        let end = moment(); end.add(minutes, 'minutes');
        let diff = end.diff(start);
        let object = moment.utc(diff).toObject();
        if(object.hours === 0) {
          return moment.duration(object.minutes, 'minutes').format('m _');
        }
        return moment.duration(object.hours, 'hours').format('h _') + ' ' +  moment.duration(object.minutes, 'minutes').format('m _')
      },
      groupedItemDate(date, duration) {
        let self = this;
        let offset = new Date();
        let dateMod = moment.utc(date).local().locale(config.language);
        return dateMod.format('dddd Do');
      },
      addDay() {
        let self = this;
        self.date = moment(self.date).add(1, 'day');
      },
      subtractDay() {
        let self = this;
        self.date = moment(self.date).subtract(1, 'day');
      },
      loadFitbitSleepLog() {
        let self = this;
        let startOfYear = moment().startOf('year').format('YYYY-MM-DD');
        SleepApi.getFitBitSleepLog(startOfYear)
          .then(function (response) {
            if (response.data.sleep.length > 0) {
              let date = moment(response.data.sleep[self.fitbitIndex].dateOfSleep);
              self.fitbitData = response.data.sleep[self.fitbitIndex];
              self.fitbitSleepLog = response.data.sleep;
              self.locksDate = true;
              self.$nextTick(function () {
                self.date = date;
                self.isLoading = false;
                self.locksDate = false;
              })
            }
          })
      },
      loadFitbitData() {
        let self = this;
        SleepApi.getFitBitData(self.date.format('YYYY-MM-DD')).then(response => {
          self.fitbitData = response.data;
          self.isLoading = false;
        })
      },
      loadStriivData() {
        let self = this;
        SleepApi.getStriivData(self.date.format('YYYY-MM-DD')).then(response => {
          self.striivData = response.data;
          self.isLoading = false;
        });
      },
      loadData() {
        let self = this;
        IntegrationApi.available.sleep()
          .then(function (response) {
            if (response.data.length > 0) {
              self.showDeviceTab = true;
              self.selectedTab = 'sleepDiary'
            }
            else {
              self.showDeviceTab = false;
              self.selectedTab = 'sleepDiary'
            }
            SleepApi.getSleepTrackingWearableDetail(1, 15)
              .then(function (response) {
                self.isReadingsLoading = false;
                self.data = response.data;
              })
          })
          .catch(function (error) {
            self.showDeviceTab = false;
            self.selectedTab = 'sleepDiary'
          });
      },
      loadMoreData() {
        let self = this, page = self.data.page, pages = self.data.pages;
        if (page >= pages) {
          self.isReadingsLoading = false;
          return;
        }
        if ((page < pages)) {
          self.isReadingsLoading = true;
          page++;
          SleepApi.getSleepTrackingWearableDetail(page, 15)
            .then(function (response) {
              self.data.page = response.data.page;
              self.data.data.push.apply(self.data.data, response.data.data);
              self.isReadingsLoading = false;
            })
        }
      },
      humanizedHours(hours) {
        return moment.duration(hours, 'hour').humanize();
      },
      goTo(name) {
        this.$router.push({
          name: name
        })
      }
    },
    computed: {
      isToday() {
        let self = this;
        return moment().isSame(self.date, 'day')
      },
      humanizeDate() {
        let self = this;
        if (moment().isSame(self.date, 'day')) {
          return 'Today';
        }
        return self.date.format('dddd, MMMM Do YYYY')
      },
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/tracking/sleep');
      self.loadData();
      EventBus.$on('sleepPusherReceived', function () {
        self.loadData();
      });

      EventBus.$on('onTrackingType_sleep', (service) => {
        self.service = service;
      });

    },
    beforeDestroy() {
      EventBus.$off('sleepReadingAdded');
      EventBus.$off('sleepPusherReceived')
    }
  }
</script>
<style scoped lang="less">
  @bgBranding: #183A43;
  .headingRow {
    padding: 12px 0;
    @media only screen and (max-width: 993px) {
      text-align: center;
      .tracking-types {
        display: inline-block;
        float: none;
      }
    }
  }
  .deviceHeading {
    text-align: center;
    .col {
      &:first-child {
        text-align: left;
      }
      .mediumTitle {
        white-space: nowrap;
        position: relative;
        top: 7px;
      }
      &:last-child {
        text-align: right;
      }
    }
  }
  .timelineSpacing.notEditMode:hover {
    background: fade(@bgBranding, 10%);
    cursor: pointer;
  }
  .whiteTitle {
    font-size: 18px !important;
    color: white !important;
  }
</style>



// WEBPACK FOOTER //
// SleepWearable.vue?21724ee8